export default "__VITE_ASSET__HKYCK9SM__"